<template>
  <div class="vis-navbar-right" @click="asideToggle">
    <div class="position-relative">
      <span class="vis-navbar-right-circle"></span>
      <span class="vis-navbar-right-notify"></span>
    </div>
    <div class="position-relative">
      <span class="vis-navbar-right-circle"></span>
      <span class="vis-navbar-right-notify"></span>
    </div>
    <div class="count-notify">{{ notificationCount }}</div>
  </div>
</template>

<script>
import {
  asideMenuCssClasses,
  validBreakpoints,
  checkBreakpoint
} from "@/shared/classes";
import toggleClasses from "../shared/toggle-classes";
import eventBus from "@/shared/global-events";
import { VisGlobalEventTypes } from '@/shared/enum/global-event-types'
import api from '@/api/visary-api'
import {openUserPreview} from "@/views/base/preview/user/utiils";
import globalState from "@/shared/global-state";

export default {
  name: "vis-aside-toggler",
  data() {
    return {
      notificationCount: 0,
      connection: null
    };
  },
  methods: {
    toggle(force) {
      const [display, mobile] = [this.display, this.mobile];
      let cssClass = asideMenuCssClasses[0];
      if (!mobile && display && checkBreakpoint(display, validBreakpoints)) {
        cssClass = `aside-menu-${display}-show`;
      }
      toggleClasses(cssClass, asideMenuCssClasses, force);
    },
    asideToggle(e) {
      e.preventDefault();
      this.toggle();
    },
    getCurrentCount() {
      if (this.connection) {
        this.connection.invoke("getCurrentCount");
      }
    },
    handleToggleSideBar(payload = {}) {
      this.toggle(payload.force);
    },
    async openUserPreview(id) {
      const data = await api.crud.get('User', id);
      openUserPreview(data)
    },
    onEvents() {
      eventBus.on(
        VisGlobalEventTypes.GET_CURRENT_NOTIFICATION_COUNT,
        this.getCurrentCount
      );
      eventBus.on(VisGlobalEventTypes.TOGGLE_SIDEBAR, this.handleToggleSideBar);
      eventBus.on(VisGlobalEventTypes.USER_PREVIEW, this.openUserPreview)
    },
    offEvents() {
      eventBus.off(
        VisGlobalEventTypes.GET_CURRENT_NOTIFICATION_COUNT,
        this.getCurrentCount
      );
      eventBus.off(VisGlobalEventTypes.TOGGLE_SIDEBAR, this.handleToggleSideBar);
      eventBus.off(VisGlobalEventTypes.USER_PREVIEW, this.openUserPreview)
    }
  },
  async mounted() {
    let connection;
    if (globalState.launchConfig.notificationHubUrl) {
      connection = this.$signalR.connectWithBaseUrl(globalState.launchConfig.notificationHubUrl, "notifications");
    } else {
      connection = this.$signalR.connectWithBaseUrl('', "wss/notification/notifications");
    }

    const vm = this;

    connection.on("sentCount", data => {
      vm.notificationCount = data;
    });
    connection.on("sendPushNotification", payload => {
      const logo =
        location.protocol + "//" + location.host + "/img/brand/white/logo.svg";
      eventBus.emit("getCurrentNotifications");

      if (!("Notification" in window)) {
        console.log("This browser does not support desktop notification");
      } else {
        let notification;
        if (Notification.permission === "granted") {
          notification = new Notification(payload.title, {
            body: payload.description || "",
            icon: logo
          });
        } else if (Notification.permission !== "denied") {
          Notification.requestPermission(function(permission) {
            if (permission === "granted") {
              notification = new Notification(payload.title, {
                body: payload.description || "",
                icon: logo
              });
            }
          });
        }
      }
    });

    vm.connection = connection;
    connection.start().then(() => {
      vm.getCurrentCount();
    });

    this.onEvents();
  },
  beforeDestroy() {
    this.offEvents();
  }
};
</script>

<style scoped lang="scss">
$color-navbar: rgba(255, 255, 255, 0.5);
$color-navbar-hover: rgba(255, 255, 255, 0.9);
$color-navbar-notify: #ebad36;
$color-navbar-notify-hover: #f2cf59;
$size: 0.15625rem;

.vis-navbar {
  &-right {
    align-items: center;
    cursor: pointer;
    display: flex;
    margin-right: 1rem;

    div {
      min-width: 0.375rem;
    }

    &-circle {
      &:before {
        bottom: 0.375rem;
      }

      &:after {
        top: 0.40625rem;
      }

      &:before,
      &:after {
        background-color: $color-navbar;
        border-radius: 1rem;
        content: "";
        height: $size;
        position: absolute;
        width: $size;
      }
    }

    &-notify {
      &:before {
        bottom: 0.0625rem;
      }

      &:after {
        top: 0.09375rem;
      }

      &:before,
      &:after {
        background: #ebad36;
        border-radius: 1rem;
        content: "";
        height: $size;
        position: absolute;
        width: $size;
      }
    }

    &:hover &-circle {
      &:before,
      &:after {
        background: $color-navbar-hover;
      }
    }

    &:hover &-notify {
      &:before,
      &:after {
        background: $color-navbar-notify-hover;
      }
    }

    .count-notify {
      color: $color-navbar-notify;
      font-size: 0.6875rem;
      font-weight: bold;
      margin-left: 0.25rem;
    }

    &:hover .count-notify {
      color: $color-navbar-notify-hover;
    }
  }
}
</style>
